var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidHourGlassEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid-hour-glass-end",
    transform: "translate(-99 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_28",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 28",
    transform: "translate(99 133)",
    fill: "#fff",
    stroke: "#fc1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_25",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 25",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(103 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_hourglass-end",
    "data-name": "solid hourglass-end",
    d: "M9.844,1.75a.656.656,0,0,0,.656-.656V.656A.656.656,0,0,0,9.844,0H.656A.656.656,0,0,0,0,.656v.438a.656.656,0,0,0,.656.656A5.426,5.426,0,0,0,3.961,7a5.426,5.426,0,0,0-3.3,5.25A.656.656,0,0,0,0,12.906v.438A.656.656,0,0,0,.656,14H9.844a.656.656,0,0,0,.656-.656v-.438a.656.656,0,0,0-.656-.656A5.426,5.426,0,0,0,6.539,7,5.426,5.426,0,0,0,9.844,1.75ZM5.25,5.688c-1.58,0-2.844-1.819-2.844-3.938H8.094C8.094,3.881,6.822,5.688,5.25,5.688Z",
    transform: "translate(107.5 142)",
    fill: "#fc1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(118 156)",
    fill: "#fc1",
    fontSize: 19,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidHourGlassEnd);
export default __webpack_public_path__ + "static/media/solid-hour-glass-end.d1df9de0cf67424d8a17898fc9d5a0f0.svg";
export { ForwardRef as ReactComponent };